import React, { useState, useEffect } from 'react';
import './Lab.css';
import { getAllDoctors } from './labApi';

const NewDoctorForm = ({ handleClose, handleCreateDoctor, initialData = null, mode = 'create', handleUpdateDoctor, handleDeleteDoctor }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        name: '',
        surname: '',
        country: '',
        region: '',
        company: '',
        inn: '',
        kpp: ''
    });
    const [image, setImage] = useState(null);
    const [photoFile, setPhotoFile] = useState(null);
    const [allDoctors, setAllDoctors] = useState([]);
    const [filteredDoctors, setFilteredDoctors] = useState([]);

    // Загружаем всех докторов при монтировании компонента
    useEffect(() => {
        getAllDoctors((res) => {
            if (res?.res && Array.isArray(res.data)) {
                console.log('getAllDoctors', res.data);
                setAllDoctors(res.data);
            }
        });
    }, []);

    // Фильтрация докторов по email
    useEffect(() => {
        const input = formData.email.toLowerCase().trim();
        if (input.length > 1) {
            console.log('input', input);
            const matches = allDoctors.filter(doc =>
                doc.email &&
                doc.email.toLowerCase().includes(input) &&
                doc.email.toLowerCase().length !== input.length // исключаем полные совпадения
            );

            console.log('matches', matches);
            setFilteredDoctors(matches);
        } else {
            setFilteredDoctors([]);
        }
    }, [formData.email, allDoctors]);

    // Prefill when editing
    useEffect(() => {
        if (initialData) {
            setFormData(prev => ({
                ...prev,
                email: initialData.email || prev.email,
                company: initialData.company || prev.company,
                name: initialData.name || prev.name,
                surname: initialData.surname || prev.surname,
                country: initialData.country || prev.country,
                region: initialData.region || prev.region,
                inn: initialData.inn || prev.inn,
                kpp: initialData.kpp || prev.kpp
            }));
            // Если у доктора есть фото на сервере — показать его в форме
            if (initialData.photo_path) {
                try {
                    const url = `${process.env.REACT_APP_API_URL}static/uploads/${initialData.photo_path}`;
                    setImage(url);
                } catch (err) {
                    // ignore
                }
            }
        }
    }, [initialData]);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSelectDoctor = (doctor) => {
        setFormData(prev => ({
            ...prev,
            email: doctor.email,
            company: doctor.company || '',
            name: doctor.name || '',
            surname: doctor.surname || '',
            country: doctor.country || '',
            region: doctor.region || '',
            inn: doctor.inn || '',
            kpp: doctor.kpp || ''
        }));
        setFilteredDoctors([]); // скрыть dropdown
    };

    const handleImagePick = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            setPhotoFile(file);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (formData.name.length < 2) {
            alert('Заполните имя');
            return;
        }

        const payload = {
            ...formData,
            photo: photoFile
        };

        if (mode === 'edit' && typeof handleUpdateDoctor === 'function' && initialData) {
            handleUpdateDoctor(initialData.doctor_id, payload);
        } else {
            handleCreateDoctor(payload);
        }
    };  

    return (
        <div className="new-doctor-form-overlay">
            <div className="new-doctor-form">
                <div className="form-header">
                    <h3>{mode === 'edit' ? 'Редактирование доктора' : 'Новый доктор'}</h3>
                    <button className="close-btn" onClick={handleClose}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    {/* Фото */}
                    <div className="photo-section">
                        <label htmlFor="photo-input" className="photo-label">
                            {image ? (
                                <img src={image} alt="Фото доктора" className="doctor-photo-preview" />
                            ) : (
                                <div className="photo-placeholder">
                                    <span>📷</span>
                                    <p>Добавить фото</p>
                                </div>
                            )}
                        </label>
                        <input
                            id="photo-input"
                            type="file"
                            accept="image/*"
                            onChange={handleImagePick}
                            style={{ display: 'none' }}
                        />
                    </div>

                    {/* Email */}
                    <div className="form-group email-group">
                        <label>Email</label>
                        <input
                            type="email"
                            value={formData.email}
                            onChange={(e) => handleInputChange('email', e.target.value)}
                            required
                        />
                        {filteredDoctors.length > 0 && (
                            <div className="email-dropdown">
                                {filteredDoctors.map((doctor) => (
                                    <div
                                        key={doctor.doctor_id}
                                        className="dropdown-option"
                                        onClick={() => handleSelectDoctor(doctor)}
                                    >
                                        {doctor.email}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Клиника */}
                    <div className="form-group">
                        <label>Клиника</label>
                        <textarea
                            value={formData.company}
                            onChange={(e) => handleInputChange('company', e.target.value)}
                            rows={3}
                            autoCapitalize="none"
                        />
                    </div>

                    {/* Имя и Фамилия */}
                    <div className="form-row">
                        <div className="form-group">
                            <label>Имя</label>
                            <input
                                type="text"
                                value={formData.name !== 'null' ? formData.name : ''}
                                onChange={(e) => handleInputChange('name', e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Фамилия</label>
                            <input
                                type="text"
                                value={formData.surname !== 'null' ? formData.surname : ''}
                                onChange={(e) => handleInputChange('surname', e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    {/* Адрес */}
                    <div className="form-row">
                        <div className="form-group">
                            <label>Адрес</label>
                            <input
                                type="text"
                                value={formData.country !== 'null' ? formData.country : ''}
                                onChange={(e) => handleInputChange('country', e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Телефон и Пароль */}
                    <div className="form-row">
                        <div className="form-group">
                            <label>Телефон</label>
                            <input
                                type="tel"
                                value={formData.region !== 'null' ? formData.region : ''}
                                onChange={(e) => handleInputChange('region', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Пароль</label>
                            <input
                                type="password"
                                value={formData.password !== 'null' ? formData.password : ''}
                                onChange={(e) => handleInputChange('password', e.target.value)}
                                required={mode !== 'edit'}
                                placeholder={mode === 'edit' ? 'Оставьте пустым, чтобы не менять' : ''}
                            />
                        </div>
                    </div>

                    {/* ИНН и КПП */}
                    <div className="form-row">
                        <div className="form-group">
                            <label>ИНН</label>
                            <input
                                type="text"
                                value={formData.inn !== 'null' ? formData.inn : ''}
                                onChange={(e) => handleInputChange('inn', e.target.value)}
                                inputMode="numeric"
                            />
                        </div>
                        <div className="form-group">
                            <label>КПП</label>
                            <input
                                type="text"
                                value={formData.kpp !== 'null' ? formData.kpp : ''}
                                onChange={(e) => handleInputChange('kpp', e.target.value)}
                                inputMode="numeric"
                            />
                        </div>
                    </div>

                    {/* Кнопки */}
                    <div className="form-actions">
                        <button type="button" onClick={handleClose} className="btn-cancel">
                            Отмена
                        </button>
                        <button type="submit" className="btn-submit">
                            {mode === 'edit' ? 'Сохранить' : 'Создать'}
                        </button>
                    </div>
                    
                    {/* Кнопка удаления (только в режиме редактирования) */}
                    {mode === 'edit' && initialData && handleDeleteDoctor && (
                        <div className="form-actions" style={{ marginTop: '10px' }}>
                            <button 
                                type="button" 
                                onClick={() => {
                                    if (window.confirm('Вы уверены, что хотите удалить этого врача?')) {
                                        handleDeleteDoctor(initialData.doctor_id);
                                        handleClose();
                                    }
                                }}
                                className="btn-delete"
                                style={{ 
                                    backgroundColor: '#dc3545', 
                                    color: 'white',
                                    width: '100%'
                                }}
                            >
                                Удалить
                            </button>
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
};

export default NewDoctorForm;
